import React, { useState, useEffect } from "react";
import Scheduler, { SchedulerData, ViewTypes, SummaryPos, DATE_FORMAT } from "react-big-scheduler";
import moment from "moment";
import "moment/locale/it";
import Col from "antd/lib/col";
import Row from "antd/lib/row";
import Button from '@mui/material/Button';
import withDragDropContext from "./withDnDContext";
import { useNotify, useDataProvider, ConfirmClasses } from 'react-admin';
import "react-big-scheduler/lib/css/style.css";
import { useRefresh } from 'react-admin';
import { useEditContext,useGetOne,useGetMany,useGetManyReference } from 'react-admin';
import {ThreeDots} from 'react-loader-spinner';
import "./a.css";
import { Typography } from "@mui/material";
import Select from 'react-select';

const DashboardDailyView_7 =  ({ enteId }) => {
  const refresh = useRefresh();
  const [loading, setLoading]= useState(true);    
  const [dataAttivita, setDataAttivita] = useState(moment().format("YYYY-MM-DD"));  
  
  let totale_partecipanti;
  let totale_partecipanti_effettivi
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [isPopoverVisible, setIsPopoverVisible] = useState(true);  

  const { data: slots, isPending2, error2 } = useGetManyReference(
      'slots',
      { 
          target: 'ente_id',
          id: enteId,
          filter: {            
            ambito_id: 7,       
          },
          pagination: { page: 1, perPage: 1000 },
          sort: { field: 'giorno', order: 'DESC' }
      }
  );
  
  const { data: prenotazioni, isPending, error } = useGetManyReference(
    'prenotazioni_7',
    { 
        target: 'ente_id',
        id: enteId,
        filter: {            
            data_attivita: dataAttivita,     
            stato_prenotazione_id_neq: 3         
          },
        pagination: { page: 1, perPage: 1000 },
        sort: { field: 'bambino_id', order: 'DESC' }
    }
  );

  const bambinoIds = prenotazioni ? [...new Set(prenotazioni.map(p => p.bambino_id))] : [];
  
  const { data: bambini, isPending: isPendingBambini, error: errorBambini } = useGetMany(
    'bambini',
    { ids: bambinoIds }
  );

  const manyItems = [...new Array(100)].map((_, i) => ({
    value: i,
    label: `${i}`,    
  }));

  const getSummary = (schedulerData, headerEvents, slotId, slotName, headerStart, headerEnd) => {
    if( totale_partecipanti_effettivi && totale_partecipanti){
     //console.log("CALLED GS",slotName,headerStart,headerEnd );
      //console.log("CALLED GS",headerStart,headerEnd,totale);
      let dd=moment(headerStart).format("HH:mm");
      //console.log("MOMENT",dd, slotName);      
        if(slotName==="Totale Partecipanti Effettivi"){
          //console.log("TOTPRE",totale_partecipanti,Object.keys(totale_partecipanti).length,dd);
          if(Object.keys(totale_partecipanti_effettivi).length > 0){
            if (dd in totale_partecipanti_effettivi) {
              //console.log("Valore p:", totale_partecipanti[dd]); 
              return {text: totale_partecipanti_effettivi[dd], color: 'black', fontSize: '0.9rem'};
            }
            else
              return {text: "0", color: 'black', fontSize: '0.9rem'};        
          }
          else
              return {text: "0", color: 'black', fontSize: '0.9rem'};        
        }
        if(slotName==="Totale Partecipanti"){
          //console.log("TOTISCR",totale_partecipanti_effettivi,Object.keys(totale_partecipanti_effettivi).length,dd);
          if(Object.keys(totale_partecipanti).length > 0){
            if (dd in totale_partecipanti) {
              //console.log("Valore i:", totale_partecipanti_effettivi[dd]); 
              return {text: totale_partecipanti[dd], color: 'black', fontSize: '0.9rem'};
            }
            else
              return {text: "0", color: 'black', fontSize: '0.9rem'};        
          }  
          else
            return {text: "0", color: 'black', fontSize: '0.9rem'};        
        }          
    }
  }

  function hasNonZeroValue(entry, time) { 
    const key = time.replace(":", "");        
    return entry[key] && entry[key] !== "0";
}

  const isNonWorkingTime = (schedulerData,time) => {
    if(slots){
      //console.log("CALLED",time,slots);
      var t=moment(time);
      //console.log("giorno",t.format("dddd"));
      const intDay=t.format("dddd");
      const foundEntry = slots.find(entry => entry.giorno === intDay);

      if (foundEntry) {
        //console.log(`Trovata  ${intDay}:`, foundEntry);
        return !hasNonZeroValue(foundEntry,t.format("HH:mm"));
      } else {
        //console.log(`Nessuna entry trovata per ${intDay}`);
        return false;
      }    
    }
    
  };
  
  
  const createSchedulerData = (events = [], resources = []) => {
    const scheduler = new SchedulerData(
      dataAttivita,  
      ViewTypes.Day,
      false,
      false,
      {
        dayStartFrom: 7,
        dayStopTo: 19,
        isEventPerspective: true,
        views: [],
        nonAgendaOtherCellHeaderFormat: "ddd D/M",
        resourceName: "Disponibilità",        
        dayResourceTableWidth:400,
        startResizable: false,
        endResizable: false,
        movable: false,
        creatable: false,
        nonWorkingTimeHeadBgColor:"white",
        nonWorkingTimeHeadColor:"black",    
        schedulerWidth:"100", 
      }
    );
    
    scheduler.setResources(resources); 
    scheduler.setEvents(events);      
    scheduler.behaviors.isNonWorkingTimeFunc= isNonWorkingTime;
    scheduler.config.summaryPos = SummaryPos.Top;
    scheduler.config.resourceTableWidth = 200;
    scheduler.behaviors.getSummaryFunc=getSummary;
    
    return scheduler;
};
 
 const [schedulerData, setSchedulerData] = useState(createSchedulerData([], []));
  
  useEffect(() => {
    moment.locale("it");
    //console.log("DATA",dataAttivita);
    //console.log("PRIMA COSA");           
    if (prenotazioni && bambini) {
      const prenotazioniConNomi = prenotazioni && bambini 
      ? prenotazioni.map(p => {
        const bambino = bambini.find(b => b.id === p.bambino_id);
        return {
          ...p,
          bambinoCF: bambino 
            ? `${bambino.codice_fiscale}` : "Sconosciuto",
          bambinoNome: bambino 
            ? `${bambino.nome} ${bambino.cognome} (${bambino.codice_fiscale})` 
            : "Sconosciuto"
        };
        })
      : [];
      console.log("Prenotazioni con nomi:", prenotazioniConNomi);

      let res=[];
      let i = 0;
      const greenCircle = String.fromCodePoint(0x1F7E2); 
      const redCircle = String.fromCodePoint(0x1F534);   
      const grayCircle = String.fromCodePoint(0x26AA); 

      while (i < prenotazioniConNomi.length) {
        let circle=String.fromCodePoint(0x1F7E2); 
        if(prenotazioniConNomi[i].valid===false)
          circle=String.fromCodePoint(0x1F534); 
        else if(prenotazioniConNomi[i].valid===true)
          circle=String.fromCodePoint(0x1F7E2); 
        else
          circle=String.fromCodePoint(0x26AA); 
        
        const prenotazione = {
          id: prenotazioniConNomi[i].bambino_id,
          //name: prenotazioniConNomi[i].bambinoNome,
          name: `${circle} ${prenotazioniConNomi[i].bambinoNome}`,          
          valid: prenotazioniConNomi[i].valid,
        };

      
        if (!res.some(p => p.id === prenotazione.id)) {
          res.push(prenotazione);
        }

        i++;
      }
      
      const pren = prenotazioniConNomi.map(prenotazione => ({
          id: parseInt(prenotazione.id),
          start: `${prenotazione.data_attivita} ${prenotazione.ora_inizio_attivita}:00`,
          end: `${prenotazione.data_attivita} ${prenotazione.ora_fine_attivita}:00`,       
          resourceId: prenotazione.bambino_id,       
          title: "",       
          name: prenotazione.bambinoNome,
          valid:prenotazione.valid,
          codiceFiscale: prenotazione.bambinoCF,
          numero_partecipanti: prenotazione.numero_partecipanti,
          numero_partecipanti_effettivi: prenotazione.numero_partecipanti_effettivi,
          inizio_reale:`${prenotazione.ora_inizio_reale}`,
          stato:prenotazione.stato_prenotazione_id,
          fine_reale:`${prenotazione.ora_fine_reale}`,
          bgColor: prenotazione.stato_prenotazione_id=='5' ? "lightgrey"
          : prenotazione.stato_prenotazione_id=='4' ? "black"
          : prenotazione.ora_inizio_reale === null && prenotazione.ora_fine_reale === null ? "lightgreen" 
          : prenotazione.ora_inizio_reale != null && prenotazione.ora_fine_reale === null ? "orange" 
          : "lightblue"
          
      }));    
        pren.sort((a, b) => new Date(a.start) - new Date(b.start));
        console.log("PP",pren);
                
        
        const timeSlotCountsPartecipanti= {}; 
        const timeSlotCountsPartecipantiEffettivi= {}; 


        const allTimeSlots = [];
        for (let hour = 7; hour <= 19; hour++) {
          const startTime = (hour < 10 ? `0${hour}` : `${hour}`) + ":00";
          allTimeSlots.push(startTime);
          allTimeSlots.push((hour < 10 ? `0${hour}` : `${hour}`) + ":30");
        }
        //console.log("test",pren, res,allTimeSlots);
        if(pren.length>0 && res.length>0){
            prenotazioniConNomi.forEach((prenotazione) => {
            console.log("AA", prenotazione);
              const startTime = moment(`${prenotazione.data_attivita} ${prenotazione.ora_inizio_attivita}:00`);
              const endTime = moment(`${prenotazione.data_attivita} ${prenotazione.ora_fine_attivita}:00`);
            
              while (startTime < endTime) {
                const key = startTime.format("HH:mm");      
            
                if(prenotazione.stato_prenotazione_id==1 || prenotazione.stato_prenotazione_id==5||prenotazione.stato_prenotazione_id==2||prenotazione.stato_prenotazione_id==6||prenotazione.stato_prenotazione_id==4){
                  if (!timeSlotCountsPartecipanti[key]) {
                    timeSlotCountsPartecipanti[key] = 0;
                  }
                  if (!timeSlotCountsPartecipantiEffettivi[key]) {
                    timeSlotCountsPartecipantiEffettivi[key] = 0;
                  }
                  //console.log("CONTEGGIO",timeSlotCountsPartecipanti[key],prenotazione.numero_partecipanti, Number(prenotazione.numero_partecipanti));
                  timeSlotCountsPartecipanti[key]=timeSlotCountsPartecipanti[key]+Number(prenotazione.numero_partecipanti);
                  timeSlotCountsPartecipantiEffettivi[key]=timeSlotCountsPartecipantiEffettivi[key]+Number(prenotazione.numero_partecipanti_effettivi);
                }                  
                startTime.add(30, 'minutes');
              }
            });
            //console.log("COUNTING",timeSlotCounts, timeSlotCountsPartecipanti, timeSlotCountsPartecipantiEffettivi);
            
            totale_partecipanti_effettivi=timeSlotCountsPartecipantiEffettivi;
            totale_partecipanti=timeSlotCountsPartecipanti;
            console.log("SOMME",totale_partecipanti, totale_partecipanti_effettivi);
            
            const ultimaRiga = {
              id: "totale_partecipanti1", 
              start: Object.keys(timeSlotCountsPartecipanti)[0], 
              end: Object.keys(timeSlotCountsPartecipanti).slice(-1)[0],               
              resourceId: "totale_partecipanti", 
              title: "", 
              bgColor: "lightgray", 
              name: "Totale Partecipanti",               
              codiceFiscale: "", 
              inizio_reale: "",
              fine_reale: "",
              conteggi: timeSlotCountsPartecipanti, 
             
            };
            //pren.push(ultimaRiga); 
            if(Object.keys(timeSlotCountsPartecipanti)[0]!= undefined)            
              pren.push(ultimaRiga); 
            
            console.log("ULTIMA",ultimaRiga);

            const ultimaRigaPiuUno = {
              id: "totale_partecipanti_effettivi1", 
              start: Object.keys(timeSlotCountsPartecipantiEffettivi)[0], 
              end: Object.keys(timeSlotCountsPartecipantiEffettivi).slice(-1)[0], 
              resourceId: "totale_partecipanti_effettivi", 
              title: "", 
              bgColor: "lightgray", 
              name: "Totale Partecipanti Effettivi", 
              codiceFiscale: "", 
              inizio_reale: "",
              fine_reale: "",
              conteggi: timeSlotCountsPartecipantiEffettivi, 
            };
            if(Object.keys(timeSlotCountsPartecipantiEffettivi)[0]!= undefined)
              pren.push(ultimaRigaPiuUno); 
            console.log("ULTIMA+1",ultimaRigaPiuUno);
            
            const rigaVuota= { id: "empty", name: "", bgColor: "#00f0f0" };
                      
            const rigaConTotale = { id: "totale_partecipanti", name: "Totale Partecipanti", bgColor: "#00f0f0" };            
            const rigaConTotaleUno = { id: "totale_partecipanti_effettivi", name: "Totale Partecipanti Effettivi", bgColor: "#00f0f0" };
            res.push(rigaVuota);
            res.push(rigaConTotale);
            res.push(rigaConTotaleUno);
            
            console.log("PREN",pren,res);
        }
        //0602
        const newSchedulerData = createSchedulerData(pren,res);
                
        setSchedulerData(newSchedulerData); 
        const timer = setTimeout(() => {
          setLoading(false);
        }, 100); 
      }
    
  },   
  [prenotazioni,bambini, dataAttivita]);
  

const prevClick = () => {
  setLoading(true); 
  const newDate = moment(dataAttivita).subtract(1, 'days').format("YYYY-MM-DD");
  setDataAttivita(newDate);
};

const nextClick = () => {
  setLoading(true); 
  const newDate = moment(dataAttivita).add(1, 'days').format("YYYY-MM-DD");
  setDataAttivita(newDate);
};


const onSelectDate = (schedulerData, date) => {
  setLoading(true); 
  const newDate = moment(date).format("YYYY-MM-DD");
  console.log(newDate);
  setDataAttivita(newDate);
};



const eventItemPopoverTemplateResolver = (schedulerData,eventItem,title,start,end,statusColor) => {
  setIsPopoverVisible(true); 
  title=eventItem.name;

  const handleRegistraIngresso = async (idP,ingressoP) => {
    console.log("HC2",idP, ingressoP);
    try {
        await dataProvider.update('prenotazioni_7', {
            id: idP,
            data: { ora_inizio_reale: ingressoP,
                    numero_partecipanti_effettivi: "1"
             },

        });
        notify('Ingresso registrato con successo', 'success');     
        refresh();
    } catch (error) {
        notify('Errore durante l\'aggiornamento', 'error');
    }
  };

  const  handleChange777 = async (event, item) => {
    if (event && event.value){     
       console.log("EV",event);        
       console.log("item",item);
       try {
        await dataProvider.update('prenotazioni_7', {
            id: item.id,
            data: { numero_partecipanti_effettivi: event.label},

        });
        notify('Ingresso registrato con successo', 'success');     
        refresh();
    } catch (error) {
        notify('Errore durante l\'aggiornamento', 'error');
    }
     }
     //doPost(id, "SettoreCodice", event.value);    
   }


  const handleRegistraUscita = async (idP,ingressoP) => {
    console.log("HC2",idP, ingressoP);
    try {
        await dataProvider.update('prenotazioni_7', {
            id: idP,
            data: { ora_fine_reale: ingressoP },
        });
        notify('Uscita registratoacon successo', 'success');           
        refresh();
    } catch (error) {
        notify('Errore durante l\'aggiornamento', 'error');
    }
  };

  const handleClick = function() {
    console.log("HC",eventItem);
    handleRegistraIngresso(eventItem.id, moment().format('HH:mm'));    
    setIsPopoverVisible(false); 
    
  }

  const handleClickExit = function() {
    console.log("HC",eventItem);
    handleRegistraUscita(eventItem.id, moment().format('HH:mm'));      
    setIsPopoverVisible(false);     
  }
  if (!isPopoverVisible) {
    return null;  
  }
  return (    
    //console.log("OVERWW",eventItem),
    <div style={{ width: "300px" }}>
      <Row type="flex" align="middle">
        <Col span={2}>
          <div
            className="status-dot"
            style={{ backgroundColor: statusColor }}
          />
        </Col>
        <Col span={22} className="overflow-text">        
          <div />        
          <span className="header2-text" title={title}>
            {title}
          </span>
        </Col>
        
      </Row>
      <Row type="flex" align="middle">
        <Col span={2}>
          <div />
        </Col>
        <Col span={22} className="overflow-text">
          <span className="header2-text" title={title}>
            Numero Partecipanti: {eventItem.numero_partecipanti}
          </span>
        </Col>
      </Row>
      <Row type="flex" align="middle">
        <Col span={2}>
          <div />
        </Col>
        <Col span={22}>
          <span className="header1-text">
            {start.format("HH:mm")} - {end.format("HH:mm")}
          </span>
        </Col>
      </Row>
      <Row type="flex" align="middle">
        <Col span={2}>
          <div />
        </Col>
        <Col span={22}>
          <span className="header1-text">
            {eventItem.stato!=5 ?(
              <div>
                {eventItem.stato==4 ?(
                  <div style={{ display:'flex', marginTop:'10px', marginBottom:'20px', width:'100%', color:"black", gap: '10px'}}>
                  ASSENTE
                </div>
                ):
                eventItem.stato==6 ?(
                  <div style={{ display:'flex', marginTop:'10px', marginBottom:'20px', width:'100%', color:"orange", gap: '10px'}}>
                  IN CORSO
                </div>
                ):
                eventItem.stato==2 ?(
                  <div style={{ display:'flex', marginTop:'10px', marginBottom:'20px', width:'100%', color:"lightblue", gap: '10px'}}>
                  CONSUNTIVATO
                </div>
                ):
                eventItem.stato==1 ?(
                  <div style={{ display:'flex', marginTop:'10px', marginBottom:'20px', width:'100%', color:"lightgreen", gap: '10px'}}>
                  PRENOTATO
                </div>
                ):
                (<></> )}
              
              <div style={{ display:'flex', marginTop:'10px', marginBottom:'20px', width:'100%', gap: '10px'}}>                 
                {eventItem.inizio_reale!="null" ?(
                  <Button disabled={true} onClick={handleClick} size="small" variant="outlined">Ingresso {eventItem.inizio_reale}</Button> 
                ):(
                  //console.log("22",moment(dataAttivita, "YYYY-MM-DD"), moment(), moment(dataAttivita, "YYYY-MM-DD").isSame(moment(), "day") , eventItem.inizio_reale!="null"),
                  <Button disabled={!moment(dataAttivita, "YYYY-MM-DD").isSame(moment(), "day") || eventItem.inizio_reale!="null" ? true:false} onClick={handleClick} size="small" variant="outlined">Inizia Evento</Button> 
                )}
                {eventItem.fine_reale!="null" ?(
                  <Button disabled={true} onClick={handleClickExit} size="small" variant="outlined">Uscita {eventItem.fine_reale}</Button> 
                ):(
                  //console.log("PDPMM",eventItem),
                  //console.log("23",moment(dataAttivita, "YYYY-MM-DD"), moment(), moment(dataAttivita, "YYYY-MM-DD").isSame(moment(), "day") , eventItem.inizio_reale!="null"),
                  <Button disabled={!moment(dataAttivita, "YYYY-MM-DD").isSame(moment(), "day") || eventItem.fine_reale!="null"|| eventItem.inizio_reale=="null" ? true:false} onClick={handleClickExit} size="small" variant="outlined">Termina Evento</Button>
                )}                
              </div>
              
              {eventItem.inizio_reale=="null" || eventItem.fine_reale!="null"? (
              <div className="header2-text"  style={{ display:'flex', marginTop:'10px', marginBottom:'20px', width:'100%', gap: '10px'}}>              
              <Typography sx={{paddingLeft:"0px", paddingTop:"7px", color:"#333333",  mb: 1.5, paddingRight:"10px" }} component={'div'}> Numero partecipanti effettivi: {eventItem.numero_partecipanti_effettivi}
              </Typography>                            
            </div>        
              ):(
                <div className="header2-text"  style={{ display:'flex', marginTop:'10px', marginBottom:'20px', width:'100%', gap: '10px'}}>
                <Typography sx={{paddingLeft:"20px", paddingTop:"7px", color:"#333333",  mb: 1.5, paddingRight:"10px" }} component={'div'}> Numero partecipanti effettivi: 
                </Typography>
                <div style={{ width: "165px", color:"black"}}>
                  <Select   optionHeight={31}              
                    //value={Number(eventItem.numero_partecipanti_effettivi)}
                    theme={(theme) => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: '#CCC8C8',
                        primary: 'black',
                      },
                    })}
                    sx={{width:"165px"}}
                    defaultValue={{
                      label: eventItem.numero_partecipanti_effettivi,
                      value: eventItem.numero_partecipanti_effettivi
                    }}
                    onChange={(event) => handleChange777(event, eventItem)}            
                    options={manyItems}/>    
                </div>
              </div>        
              )}

             </div> 
            ):(
              <div style={{ display:'flex', marginTop:'10px', marginBottom:'20px', width:'100%', color:"lightgrey", gap: '10px'}}>
                PREISCRIZIONE
              </div>
            )}
          </span>
          <span className="header1-text">
              <div style={{ display:'flex', marginTop:'10px', marginBottom:'20px', width:'100%', gap: '10px'}}>

              {eventItem.valid === true ? (
                  <Typography style={{ color: 'green' }}>PAGATA</Typography>
                ): eventItem.valid === false ? (
                  <Typography style={{ color: 'red' }}>DA PAGARE/SALDARE</Typography>
                ):(
                  <Typography style={{ color: 'grey' }}>GRATUITA</Typography>
                
                )}   
                
              </div>
          </span>
        </Col>
      </Row>
     
    </div>
  );
};



const toggleExpandFunc = (schedulerData, slotId) => {
  schedulerData.toggleExpandStatus(slotId);
  setSchedulerData(schedulerData);
};


  return (
    <div >
         {loading ? (
        <div style={{ width:"25%",   display: "flex", marginLeft: "auto", marginRight: "auto" }}>
          <ThreeDots color="#2196F3" height='350' width='150'/>
        </div>
      ):(      
        
      <Scheduler                
        //key={reloadKey}
        schedulerData={schedulerData}
        prevClick={prevClick}
        nextClick={nextClick}
        onSelectDate={onSelectDate}
        //onViewChange={onViewChange}
        //eventItemClick={eventClicked}
        toggleExpandFunc={toggleExpandFunc}  
        eventItemPopoverTemplateResolver = {eventItemPopoverTemplateResolver}    
        //eventItemTemplateResolver = {eventItemTemplateResolver}
      />           
      )}
    </div>
  );
};

export default withDragDropContext(DashboardDailyView_7);
